import { Component } from '@angular/core';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { TranslateModule } from '@ngx-translate/core';

import { ControlDataComponent } from '../control-data.component';

@Component({
  selector: 'kyc-control-data-gerl',
  imports: [NxIconModule, TranslateModule],
  templateUrl: './control-data-gerl.component.html',
  styleUrl: './control-data-gerl.component.scss',
})
export class ControlDataGerlComponent extends ControlDataComponent {
  protected getData = (i: number) => this.publicData()[i].data[0];
}
